import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  pure: true
})
export class TruncatePipe implements PipeTransform {
  /**
   * Truncate string to length.
   * @param value input string
   * @param limit max length (default 100)
   * @param suffix string to append when truncated (default '…')
   * @param preserveWords if true, break at last space before limit (default true)
   */
  transform(value: string | null | undefined, limit = 10, suffix = '…', preserveWords = true): string {
    if (value == null) return '';
    const str = String(value);

    if (limit <= 0) return '';

    if (str.length <= limit) {
      return str;
    }

    if (!preserveWords) {
      return str.slice(0, limit) + suffix;
    }

    // preserve last whole word if possible
    const truncated = str.slice(0, limit);
    const lastSpace = truncated.lastIndexOf(' ');
    if (lastSpace > 0) {
      return truncated.slice(0, lastSpace) + suffix;
    }
    // no space found — just hard cut
    return truncated + suffix;
  }
}
